import { StandardButton } from "../atoms/buttons";
import { icon } from "../functions/icons";
import { HorizontalLayout } from "./layout";
import {IconAlertTriangleFilled, IconCheck, IconExclamationCircleFilled, IconInfoCircleFilled, IconBulb} from '@tabler/icons-react'


export function Alert({type = "success", title, message, marginTop, className, buttonText, onClick, dismissable, marginLeft, marginRight}) {
    const isSuggestion = type === "suggestion";
    return (

        <div data-testid={"alert-1"} className={`${className} phone-alert alert relative ${type}-alert`} style={{marginTop:marginTop, marginLeft:marginLeft, marginRight:marginRight, width: "auto",}}>

            {dismissable && <div className="alert-xmark" onClick={dismissable}>{icon("x", 16)}</div> }
            <HorizontalLayout style={{"alignItems": title ? "start" : "center"}}>
                <div className="alert-icon" style={{color: `var(--${type}-500)`,valignSelf: title ? "center" : ""}}>
                    {alerticon(type)}
                </div>
                <div className="ai-alert">
                    {title && <div className="alert-title" style={{color: `var(--${type}-600)`}}>{title}</div>}
                    <div style={{color: `var(--${type}-500)`, "fontSize": "12px"}}>{message}</div>
                </div>
                {isSuggestion && buttonText && ( <StandardButton size="medium" backgroundColor="suggestion-600" textColor="white" onClick={onClick} title={buttonText} arrow={"right"}/>)}
            </HorizontalLayout>
        </div>
    )
}

function alerticon(type){
    switch(type){
        case "success":return <IconCheck/>
        case "warning":return <IconAlertTriangleFilled/>
        case "error":return <IconExclamationCircleFilled/>
        case "info":return <IconInfoCircleFilled/>
        case "suggestion": return <IconBulb />
    }
}